// extracted by mini-css-extract-plugin
export default {"xcard":"XCard_xcard__Trlu9","xcard_actions":"XCard_xcard_actions__zKVHM","xcard_loader":"XCard_xcard_loader__thQz-","empty":"XCard_empty__CTwY8"};